import { render, staticRenderFns } from "./LegalView.vue?vue&type=template&id=e4d8be70&"
import script from "./LegalView.vue?vue&type=script&lang=js&"
export * from "./LegalView.vue?vue&type=script&lang=js&"
import style0 from "./LegalView.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports